import { DoBootstrap, Injector, NgModule } from '@angular/core';

import { createCustomElement } from '@angular/elements';
import { TimerElement } from './timer.component';

@NgModule({
    declarations: [TimerElement],
    exports: [TimerElement],
})
export class TimerModule implements DoBootstrap {
    constructor(private injector: Injector) {}

    ngDoBootstrap(): void {
        const el = createCustomElement(TimerElement, {
            injector: this.injector,
        });

        customElements.define('bazis-timer', el);
    }
}
